import { DrupalIdentifier } from './drupal-node.model';
import { Expose, Transform } from 'class-transformer';

export class AppPathInfos extends DrupalIdentifier {
  @Expose()
  language!: string;

  @Expose()
  path!: string;

  @Transform(({ obj }) => {
    return `${obj.path ?? ''}`;
  })
  @Expose()
  canonicalUrl!: string;

  @Expose()
  title!: string;

  @Expose()
  description!: string;

  @Expose()
  frontPage!: boolean;

  @Expose()
  meta!: any;
}
